export const RatingStyles = {
  STARS: 'STARS',
  NPS: 'NPS',
  THUMBS: 'THUMBS',
  EMOJI: 'EMOJI',
};

// Score values sent to the BE per style: stars / emoji 1-5, NPS 0-10,
// thumbs 1 (up) / 0 (down).
export const STAR_SCORES = [1, 2, 3, 4, 5];
export const NPS_SCORES = Array.from({ length: 11 }, (_, index) => index);
export const EMOJI_SCORES = [1, 2, 3, 4, 5];
export const ThumbScores = {
  UP: 1,
  DOWN: 0,
};

export const FeedbackSteps = {
  RATING: 'RATING',
  LOW_SCORE: 'LOW_SCORE',
  THANK_YOU: 'THANK_YOU',
};
